import "./AccessTab.css";

import { OrganisationTypeConstants, ProjectPermissionConstants } from "../../../../../constants";
import { useAuth } from "../../../../../useAuth";
import { Button, Column, CursorDataGrid, Row } from "../../../../../widget";
import { useAccessTabReceivedData } from "./useAccessTabReceivedData";
import { useAccessTabSentData } from "./useAccessTabSentData";

export const AccessTab = (): JSX.Element => {
  const { currentUserType } = useAuth();
  const { receivedColumns, defaultSortingCriteriaReceived, receivedDataIsLoading, receivedOnChange, hasPermission } =
    useAccessTabReceivedData();
  const { onNewInvitation, sentColumns, defaultSortingCriteriaSent, sentDataIsLoading, sentOnChange } =
    useAccessTabSentData();
  const isAssetManager = currentUserType === OrganisationTypeConstants.ASSET_MANAGER;

  return (
    <div className={`SettingsProjectAccessTab${isAssetManager ? " TemplateTabCard" : ""}`}>
      <Row spacingV="ll">
        <Column span={12}>
          <div className="AccessHeader">
            <h2>Sent</h2>
            {hasPermission(ProjectPermissionConstants.ACCEPT_REJECT_PROJECT_ORGANISATION_INVITATION) && (
              <Button
                text="New invitation"
                onClick={onNewInvitation}
                corners={isAssetManager ? "rounded" : "default"}
              />
            )}
          </div>
        </Column>
      </Row>
      <Row spacingV="ll">
        <Column span={12}>
          <CursorDataGrid
            columns={sentColumns}
            clientSide={false}
            filterable
            onChange={sentOnChange}
            data={[]}
            noDataMessage="No invitations to display"
            dataIsLoading={sentDataIsLoading}
            defaultSortingCriteria={defaultSortingCriteriaSent}
            variant={isAssetManager ? "seed" : "default"}
          />
        </Column>
      </Row>
      <Row spacingV="ll">
        <Column span={12}>
          <h2>Received</h2>
        </Column>
      </Row>
      <Row>
        <Column span={12}>
          <CursorDataGrid
            columns={receivedColumns}
            clientSide={false}
            filterable
            onChange={receivedOnChange}
            data={[]}
            noDataMessage="No invitations to display"
            dataIsLoading={receivedDataIsLoading}
            defaultSortingCriteria={defaultSortingCriteriaReceived}
            variant={isAssetManager ? "seed" : "default"}
          />
        </Column>
      </Row>
    </div>
  );
};
